import React, { memo, useEffect } from "react";
import { AlertDialog } from "../common/AlertDailog";
import { useSites } from "../../hooks/useSites";
import { useSnackbar } from "../../hooks/useSnackbar";
import { useAppDispatch, useAppSelector, AppState } from "../../store";
import { setOpenDeleteSite } from "../../store/slices/studiesSlice";
import { useParams } from "react-router-dom";

const DeleteSiteDialog: React.FunctionComponent<any> = (props) => {
  const { showSuccess, handleError } = useSnackbar();
  const { paginationModel, filterVal, getAllSitesFunc, setOpenSiteDetails } =
    props;
  const {
    deleteSite,
    deleteSiteData,
    deleteSiteIsError,
    deleteSiteError,
    deleteSiteIsSuccess,
  } = useSites();
  const dispatch = useAppDispatch();
  const params = useParams();
  const siteData = useAppSelector(
    (state: AppState) => state.studiesSlice.siteDetails
  );
  const openDelete = useAppSelector(
    (state: AppState) => state.studiesSlice.openDeleteSite
  );
  const handleCloseDeleteSite = () => {
    dispatch(setOpenDeleteSite(false));
  };
  const handleDeleteSite = () => {
    deleteSite({ study_id: params?.study_id, site_id: siteData?.site_id });
  };
  useEffect(() => {
    if (deleteSiteIsSuccess) {
      const successMsg = deleteSiteData;
      getAllSitesFunc(0, paginationModel?.pageSize, filterVal);
      showSuccess(successMsg?.details, "site-delete-success");
      handleCloseDeleteSite();
      setOpenSiteDetails && setOpenSiteDetails(false);
    }
  }, [deleteSiteIsSuccess]);
  useEffect(() => {
    if (deleteSiteIsError) {
      const errorMsg: any = deleteSiteError;
      handleError(errorMsg);
    }
  }, [deleteSiteIsError]);
  return (
    <>
      <AlertDialog
        open={openDelete}
        title="Delete Site"
        description={`Are you sure you want to delete the site <strong>${siteData?.name}</strong>?`}
        handleClose={handleCloseDeleteSite}
        handleConfirm={handleDeleteSite}
        confirmBtn="Yes"
        cancelBtn="No"
        maxWidth="xs"
      />
    </>
  );
};

export default memo(DeleteSiteDialog);
